module.exports = __webpack_public_path__ + "img/sector.673db5ae.svg";